var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"value",rawName:"v-value",value:(_vm.value),expression:"value"}],attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', _vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }